import { Shot } from "./Shot.tsx";
import { SITE_NAME } from "../lib/site.ts";

export function Why() {
  return (
    <section id="why" className="relative scroll-mt-24 overflow-hidden">
      <div className="mx-auto grid w-full max-w-6xl items-center gap-12 px-6 py-24 sm:py-32 lg:grid-cols-2 lg:gap-16">
        <div>
          <div data-reveal="" style={{ ["--reveal-delay" as string]: "0ms" }}>
            <p className="font-mono text-xs tracking-wide text-muted-foreground/70">Why {SITE_NAME}</p>
            <p className="mt-4 text-balance text-2xl font-semibold leading-snug tracking-tight text-foreground sm:text-3xl">
              提醒内容自己定，场景不受限
            </p>
          </div>
          <div
            data-reveal=""
            style={{ ["--reveal-delay" as string]: "80ms" }}
            className="mt-8 space-y-6 text-lg leading-relaxed text-muted-foreground"
          >
            <p>
              产品名叫{SITE_NAME}，但提醒文字由你决定——也可以用于补水、拉伸、活动肩颈或眺望远处。
              设置提醒间隔、倒计时、工作时段和生效星期，让提醒只在合适的时间出现。
            </p>
            <p>
              将会议、演示、剪辑等应用加入白名单，命中当前应用时自动跳过本次提醒。配置提示文字、文字颜色、背景类型和倒计时预览，触发前就能确认实际效果。
            </p>
          </div>
        </div>

        <div data-reveal="" style={{ ["--reveal-delay" as string]: "120ms" }}>
          <Shot
            src="/settings-appearance.png"
            alt="肛了么外观设置：提示文字、倒计时样式与提醒屏保预览"
          />
        </div>
      </div>
    </section>
  );
}
